<script>
import { mapMutations } from "vuex";

import DialogLayout from "@layouts/dialog.layout.vue";

import userMixin from "@mixin/user.mixin";

export default {
  name: "InspectionDialogComponent",
  components: {
    DialogLayout,
  },
  mixins: [userMixin],
  props: {
    contract: { type: Object, required: true },
  },
  data() {
    return {
      warehouse: null,
      shelf: null,
    };
  },
  computed: {
    warehouseEmployee() {
      return this.$store.getters["user/warehouse"];
    },
    shelfes() {
      return [
        "Regal 1",
        "Regal 2",
        "Regal 3",
        "Regal 4",
        "Regal 5",
        "Regal 6",
        "Service",
        "Palettenplatz",
      ];
    },
  },
  methods: {
    ...mapMutations({
      logError: "ui/error",
      logMessage: "ui/log",
    }),
    close(action) {
      action();
      this.$emit("close");
    },
    async save(action) {
      try {
        await this.axios.post(
          "/contract/" + this.contract.contract_id + "/material",
          {
            employee: this.warehouse,
            shelf: this.shelf,
          }
        );
        this.logMessage("Das Material wurde bereitgestellt");
        this.$emit("update:contract");
        this.close(action);
      } catch (error) {
        this.logError("Es ist ein fehler aufgetreten");
      }
    },
  },
};
</script>

<template>
  <DialogLayout title="Material bereitgestellt" width="400">
    <template #activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs" />
    </template>
    <template #default>
      <v-select
        v-model="warehouse"
        :items="selectable(warehouseEmployee, warehouse)"
        item-text="data.long"
        item-value="id"
        label="Bereitgestellt von"
      />
      <v-select v-model="shelf" :items="shelfes" label="Ablageort" />
    </template>
    <template #action="{ action }">
      <v-spacer></v-spacer>
      <v-btn color="error" text @click="close(action)">Abbrechen</v-btn>
      <v-btn color="primary" text @click="save(action)">Freigeben</v-btn>
    </template>
  </DialogLayout>
</template>
